
		<svg width="60" height="60" version="1.1" viewBox="0 0 15.875 15.875" xmlns="http://www.w3.org/2000/svg">
			<g fill="none" stroke="#0C3121" stroke-linecap="round" stroke-linejoin="round">
				<path d="m2.854 2.8187 10.287 10.378m2.2142-5.2252a7.4083 7.4083
				0 0 1-7.4083 7.4083 7.4083 7.4083 0 0 1-7.4083-7.4083 7.4083 7.4083
				0 0 1 7.4083-7.4083 7.4083 7.4083 0 0 1 7.4083 7.4083z"
				stroke-width="1.0583" style="paint-order:normal"/>
				<path d="m10.084 6.534c0.25502-0.15699 0.56343-0.21455 0.85884-0.26363
				0.21154-0.035146 0.44644 0.065481 0.64302-0.020228 0.36091-0.15736
				0.68117-0.47553 0.83063-0.83978 0.17483-0.42611
				0.25132-0.99687-0.0017-1.3818-0.02954-0.044928-0.09701-0.08121-0.148-0.064154-0.28853
				0.096535-0.21642 0.59941-0.45041 0.79387-0.14866 0.12355-0.35576 0.20707-0.54822
				0.18904-0.20944-0.019624-0.41924-0.14663-0.54802-0.31297-0.11474-0.1482-0.17036-0.35649-0.14767-0.54254
				0.03708-0.30407 0.40199-0.49977 0.44741-0.80271 0.0071-0.047727
				0.01216-0.11864-0.03031-0.14158-0.34561-0.18674-0.79423 0.17758-1.0991
				0.42535-0.28686 0.23314-0.49737 0.57637-0.60321 0.93054-0.07582 0.25371
				0.05476 0.5363-0.00455 0.79438-0.031821 0.13859-0.10214 0.26858-0.18393
				0.3849l-3.352 3.5715c-0.25587 0.15559-0.56459 0.21146-0.86027 0.25892-0.21173
				0.033986-0.44608-0.067927-0.64312 0.016703-0.36177 0.15538-0.68377
				0.47179-0.83522 0.83522-0.17717 0.42515-0.25678 0.99548-0.0059
				1.3817 0.029287 0.04509 0.096564 0.08174 0.14765 0.06496 0.28905-0.09495
				0.2197-0.59821 0.45475-0.79139 0.14934-0.12273 0.35689-0.20512 0.54925-0.18604
				0.20933 0.02077 0.41843 0.14892 0.54629 0.31596 0.11393 0.14883 0.16841 0.35742
				0.14469 0.54334-0.038753 0.30386-0.40473 0.49756-0.4518 0.80025-0.00742 0.04769-0.012805
				0.11857 0.02953 0.14174 0.34461 0.18863 0.79523-0.17322 1.1014-0.41932 0.28813-0.23156
				0.50052-0.57364 0.60831-0.92722 0.077211-0.25329-0.051819-0.53659 0.00886-0.79434 0.032585-0.13841
				0.10361-0.26802 0.18604-0.38388z" stroke-width=".52917" style="paint-order:normal"/>
			</g>
		</svg>
	